import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

export const PlayerWrapper = styled("div")(({ theme }) => ({
  bottom: 10,
  display: "flex",
  fontSize: "16px",
  justifyContent: "center",
  left: 0,
  pointerEvents: "none",
  position: "absolute",
  right: 0,
  maxWidth: "100%",

  "& .player-stack": {
    /* TODO: frosted class unification */
    background: "rgba(255, 255, 255, .8)",
    backdropFilter: "blur(2px)",
    borderRadius: 4,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, .1)",
    color: theme.palette.text.primary,
    paddingLeft: 5,
    pointerEvents: "all",
    position: "relative",
    zIndex: 450,
  },

  "& .player-time": {
    lineHeight: 1,
    paddingInline: theme.spacing(1),
    textAlign: "center",
  },

  "& .player-time--small": {
    fontSize: "14px",
  },

  "& .player-slider": {
    color: "black",
    marginInline: theme.spacing(2),
    width: 160,
  },

  "& .player-icon": {
    color: "black",
  },
  "& .player-icon--inactive": {
    color: "grey",
  },
}));

export const StyledSlider = styled(Slider)(() => ({
  ".MuiSlider-rail": {
    background: "white",
    height: 8,
    opacity: 1,
  },
  ".MuiSlider-track": {
    background: "black",
    height: 8,
  },
  ".MuiSlider-thumb": {
    background: "black",
    boxShadow: "none",
    height: 12,
    width: 12,
  },
}));
